/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  metrics(campaignId) {
    return axios.get(`${this.url}/${campaignId}/metrics`);
  }

  summary(campaignId) {
    return axios.get(`${this.url}/${campaignId}/summary`);
  }

  audienceEstimate(params) {
    const payload = Array.isArray(params) ? { label_ids: params } : params;
    return axios.post(`${this.url}/audience_estimate`, payload);
  }

  audienceSuggest({ templateName, templateContent }) {
    return axios.post(`${this.url}/audience_suggest`, {
      template_name: templateName,
      template_content: templateContent,
    });
  }

  optimalSendTime(params = {}) {
    return axios.get(`${this.url}/optimal_send_time`, { params });
  }

  generateCopy({ templateName, templateBody, campaignGoal }) {
    return axios.post(`${this.url}/generate_copy`, {
      template_name: templateName,
      template_body: templateBody,
      campaign_goal: campaignGoal,
    });
  }

  createAbTest(params) {
    return axios.post(`${this.url}/create_ab_test`, params);
  }

  abComparison(campaignId) {
    return axios.get(`${this.url}/${campaignId}/ab_comparison`);
  }

  abWinner(campaignId) {
    return axios.get(`${this.url}/${campaignId}/ab_winner`);
  }

  mmMetrics(campaignId) {
    return axios.get(`${this.url}/${campaignId}/mm_metrics`);
  }

  suppressions(campaignId) {
    return axios.get(`${this.url}/${campaignId}/suppressions`);
  }

  intelligence({ inboxId, since, until }) {
    return axios.get(`${this.url}/intelligence`, {
      params: { inbox_id: inboxId, since, until },
    });
  }

  whatsappInboxSummaries() {
    return axios.get(`${this.url}/whatsapp_inbox_summaries`);
  }

  preflight(params) {
    return axios.post(`${this.url}/preflight`, params);
  }

  sendPlan(params) {
    return axios.post(`${this.url}/send_plan`, params);
  }

  launch(campaignId, params = {}) {
    return axios.post(`${this.url}/${campaignId}/launch`, params);
  }

  cancel(campaignId) {
    return axios.post(`${this.url}/${campaignId}/cancel`);
  }

  testSend(campaignId, params = {}) {
    return axios.post(`${this.url}/${campaignId}/test_send`, params);
  }

  qualifiedAudiencePreview(params = {}) {
    return axios.post(`${this.url}/qualified_audience_preview`, params);
  }

  qualifiedAudienceApply(params = {}) {
    return axios.post(`${this.url}/qualified_audience_apply`, params);
  }

  batchDraftCampaigns(params = {}) {
    return axios.post(`${this.url}/batch_draft_campaigns`, params);
  }
}

export default new CampaignsAPI();
